import { render, staticRenderFns } from "./authRedirect.vue?vue&type=template&id=3624ed94"
import script from "./authRedirect.vue?vue&type=script&lang=js"
export * from "./authRedirect.vue?vue&type=script&lang=js"
import style0 from "./authRedirect.vue?vue&type=style&index=0&id=3624ed94&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports